export default __webpack_public_path__ + "static/product-2-9f88da37736f09a49aaab056177ea432.png";